import { config } from "../helpers/domain-config";

export const isMobioVr = config.productName === "mobiovr" ? true : false;
